import GoogleMapsClient from './GoogleMapsClient.js';

export default {
  GoogleMapsClient,
};
